import moment from "moment";
import React, { useEffect, useState } from "react";
import { GetappointmentsbyPut } from "../../../api/helper";
import { useSelector } from "react-redux";

const VisitsPatientdetails = ({ info }) => {
  const [appointments, setAppointments] = useState([]);
  const profileData = useSelector((state) => state?.cookies?.userDetails);

  useEffect(() => {
    const FetchAppointment = async () => {
      const data = {
        patientId: info?._id,
        agencyId: profileData?._id,
        page: 1,
        limit: 100,
      };
      try {
        const respo = await GetappointmentsbyPut(data);
        setAppointments(respo?.data?.data?.appointments || []);
      } catch (error) {
        console.log(error, "error---");
      }
    };

    FetchAppointment();
  }, []);

  // 🔍 Filter into Upcoming & Previous
  const now = moment();
  const upcomingAppointments = appointments.filter((app) =>
    moment(`${app.date.split("T")[0]} ${app.startTime}`).isSameOrAfter(now)
  );
  const previousAppointments = appointments.filter((app) =>
    moment(`${app.date.split("T")[0]} ${app.startTime}`).isBefore(now)
  );

  const renderTable = (data, title) => (
    <div className="appointments-table-container_CalendarView">
      <h3 style={{ marginBottom: 10 }}>{title}</h3>
      <table className="appointments-table_CalendarView">
        <thead>
          <tr>
            <th>SessionID</th>
            <th>Client</th>
            <th>Provider</th>
            <th>Type</th>
            <th>Payment Method</th>
            <th>Duration</th>
            <th>Billing Unit</th>
            <th>SubTotal</th>
            <th>Visit Reason</th>
            <th>Date</th>
            <th>Location</th>
            <th>PA Number</th>
            <th>Ref. NPI</th>
            <th>Status</th>
            <th>Create Note</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((app) => (
            <tr key={app?._id}>
              <td>{app?._id?.slice(-7)}</td>
              <td>{app?.patientRequestId?.firstName} {app?.patientRequestId?.lastName}</td>
              <td>{app?.doctorRequestId?.firstName} {app?.doctorRequestId?.lastName}</td>
              <td>{app?.deliveryMode?.name || app?.appointmentType}</td>
              <td>{app?.paymentSource}</td>
              <td>{app?.Duration}</td>
              <td>{"2"}</td>
              <td>{"$150.00"}</td>
              <td>{app?.visitReason?.visitReason}</td>
              <td>{app?.date ? moment(app.date).format("DD/MM/YYYY") : ""} {app?.startTime}</td>
              <td>{app?.serviceLocationId?.name}</td>
              <td>{app?.authorizationDetailId?.Auth || "Not Available"}</td>
              <td>{"999999999"}</td>
              <td>
                <span
                  className="status-badge_two"
                  style={{
                    background: app?.appointmentStatus?.color,
                    color: "white",
                  }}
                >
                  {app?.appointmentStatus?.name || "Pending"}
                </span>
              </td>
              <td><button className="custom-action-button">Create Note</button></td>
              <td><button className="custom-action-button">Actions</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return ( 
    <div>
      <div className="upcomingappointment_style">
      {renderTable(upcomingAppointments, "Upcoming Appointments")}
      </div>
    <div className="upcomingappointment_style" style={{marginTop:20}}>
      {renderTable(previousAppointments, "Previous Appointments")}
      </div>
    </div>
  );
};

export default VisitsPatientdetails;

